module.exports = __webpack_public_path__ + "img/D201503_6.6dba8275.jpg";